import React, { Children } from "react";

export default function FormContainer({ children }) {
  // console.log(Children);
  return (
    <section className="bg-gray-900">
      <div className="flex flex-col items-center justify-center px-6 py-8 mx-auto h-screen lg:py-0">
        {Children.map(children, (child) => child)}
      </div>
    </section>
  );
}
